
import { CartAddEvent } from '@theme/events';
document.querySelectorAll('.wm-native').forEach(root => {
  // Keep the mobile layout as previously approved; desktop waits for both choices.
  const mobileInitial=window.matchMedia('(max-width:900px)').matches;
  let mode=mobileInitial?'standard':null;
  const picker=root.querySelector('[data-size]'),sizeChoices=[...root.querySelectorAll('[data-size-choice]')],inputs=[...root.querySelectorAll('[data-qty]')];
  const modes=[...root.querySelectorAll('[data-mode]')],standard=root.querySelector('[data-standard]'),custom=root.querySelector('[data-custom]');
  const add=root.querySelector('[data-add]'),error=root.querySelector('[data-error]');
  const choiceHint=root.querySelector('[data-choice-hint]');
  if(!mobileInitial)picker.selectedIndex=-1;
  const selected=()=>picker.selectedIndex>=0?picker.options[picker.selectedIndex]:null;
  const target=()=>Number(selected()?.dataset.size)||300;
  const style=()=>selected()?.dataset.style || 'denominated';
  const activeInputs=()=>inputs.filter(i=>i.dataset.style===style());
  // Hermes mapping: $1 White, $5 Pink, $25 Green, $50 Purple,
  // $100 Gray, $500 Orange, $1000 Yellow, $5000 Blue.
  // Six-color preset uses six denominations; Purple and Blue stay customizable.
  const mix=(t,s)=>s==='denominated'?
    (t===300?{'Denominated 1':50,'Denominated 5':100,'Denominated 25':50,'Denominated 100':50,'Denominated 500':25,'Denominated 1000':25}
            :{'Denominated 1':100,'Denominated 5':150,'Denominated 25':100,'Denominated 100':100,'Denominated 500':25,'Denominated 1000':25}):
    (t===300?{'White':50,'Pink':100,'Green':50,'Gray':50,'Orange':25,'Yellow':25}
            :{'White':100,'Pink':150,'Green':100,'Gray':100,'Orange':25,'Yellow':25});
  const money=(c)=>'$'+(c/100).toFixed(2);
  function state(){
    let sum=0,invalid=false;const chosen=[];
    for(const input of activeInputs()){
      const n=Number(input.value),stock=Number(input.dataset.stock);
      if(!Number.isInteger(n)||n<0||n%25!==0||n>stock)invalid=true;
      if(Number.isFinite(n))sum+=n;
      if(n>0)chosen.push({id:Number(input.dataset.variant),qty:n,denom:input.dataset.denom,cents:Number(input.dataset.price)});
    }
    const expected=target()===300?21900:31900;
    const hasSet=Boolean(selected());
    const baseCents=Number(selected()?.dataset.basePrice||0);
    const total=baseCents+chosen.reduce((a,c)=>a+c.qty*c.cents,0);
    const fixedMix=mix(target(),style()),fixedChosen=[];
    let fixedValid=true,fixedSum=0;
    for(const [denom,qty] of Object.entries(fixedMix)){
      const input=inputs.find(i=>i.dataset.denom===denom);
      if(!input||Number(input.dataset.variant)<=0||Number(input.dataset.stock)<qty||Number(input.dataset.price)!==50){fixedValid=false;continue;}
      fixedChosen.push({id:Number(input.dataset.variant),qty,denom,cents:Number(input.dataset.price)});
      fixedSum+=qty;
    }
    const fixedTotal=baseCents+fixedChosen.reduce((a,c)=>a+c.qty*c.cents,0);
    const standardValid=hasSet&&fixedValid&&fixedSum===target()&&fixedTotal===expected&&baseCents===6900;
    const customValid=hasSet&&!invalid&&sum===target()&&chosen.length>0&&total===expected&&baseCents===6900;
    return {sum,chosen,invalid,expected,total,fixedChosen,fixedTotal,valid:mode==='standard'?standardValid:mode==='custom'?customValid:false};
  }
  function renderPresetVisual(size,chipStyle,preset){
    const preview=root.querySelector('[data-preset-preview]');
    if(!preview)return;
    preview.hidden=mode!=='standard'||!selected();
    if(preview.hidden)return;
    const signature=size+'-'+chipStyle;
    if(preview.dataset.signature===signature)return;
    preview.dataset.signature=signature;
    preview.querySelector('[data-preset-preview-title]').textContent=size+' Chips · '+(chipStyle==='denominated'?'Denominated':'Non-Denominated');
    preview.querySelector('[data-preset-preview-price]').textContent=size===300?'$219':'$319';
    const fragment=document.createDocumentFragment();
    for(const [key,qty] of Object.entries(preset)){
      const sample=[...root.querySelectorAll('[data-fixed]')].find(el=>el.dataset.fixed===key)?.querySelector('img');
      const cell=document.createElement('div');cell.className='wm-native-preset-visual__chip';
      if(sample){
        const image=document.createElement('img');
        image.src=sample.dataset.large||sample.src;image.alt=key;image.loading='eager';image.decoding='async';cell.appendChild(image);
      }
      // Keep label and quantity together to free more space for the large chip photo.
      const name=document.createElement('span');
      const label=chipStyle==='denominated'?'$'+key.replace('Denominated ',''):key;
      name.textContent=label+' × '+qty;
      cell.appendChild(name);
      fragment.appendChild(cell);
    }
    preview.querySelector('[data-preset-preview-grid]').replaceChildren(fragment);
  }
  function render(){
    const s=state(),t=target(),setStyle=style(),defaultMix=mix(t,setStyle);
    const ready=Boolean(mode&&selected());
    standard.hidden=!ready||mode!=='standard';
    custom.hidden=!ready||mode!=='custom';
    choiceHint.hidden=ready;
    if(!ready)choiceHint.textContent=!mode&&!selected()?'Choose a set type and size to continue.':!mode?'Choose Preset Mix or Build Your Own to continue.':'Choose a set size & style to continue.';
    modes.forEach(b=>{
      const active=b.dataset.mode===mode;
      b.classList.toggle('is-active',active);
      b.setAttribute('aria-pressed',String(active));
    });
    sizeChoices.forEach(b=>{
      const active=b.dataset.sizeChoice===picker.value;
      b.classList.toggle('is-active',active);
      b.setAttribute('aria-pressed',String(active));
    });
    root.querySelectorAll('[data-fixed]').forEach(div=>{
      const count=defaultMix[div.dataset.fixed]||0;
      div.hidden=div.dataset.style!==setStyle||count===0;
      div.querySelector('[data-fixed-count]').textContent='× '+count;
    });
    root.querySelector('.wm-native-fixed').classList.toggle('is-non-denominated',setStyle==='non-denominated');
    root.querySelectorAll('.wm-native-chip').forEach(div=>div.hidden=div.dataset.style!==setStyle);
    root.querySelector('[data-standard-heading]').textContent=setStyle==='denominated'?'3. Preset Denomination Breakdown':'3. Preset Color Breakdown';
    root.querySelector('[data-custom-heading]').textContent=setStyle==='denominated'?'3. Customize Your Denominations Breakdown':'3. Customize Your Color Breakdown';
    root.querySelector('[data-preset-note]').hidden=!ready||mode!=='standard'||setStyle!=='non-denominated';
    renderPresetVisual(t,setStyle,defaultMix);
    root.querySelector('[data-total]').textContent=selected()?money(s.expected):'—';
    add.disabled=!ready||!s.valid;
    add.textContent=!ready?'Add to Cart':mode==='standard'?'Add Preset Mix to Cart':'Add Custom Set to Cart';
    const tooMany=s.sum>t;custom.classList.toggle('wm-native-over',tooMany);
    const hint=tooMany?(s.sum-t)+' chips too many — please reduce':s.sum===t?
      (s.invalid?'Invalid quantities':s.total!==s.expected?'Price mismatch — review SKU prices':'Ready to add to cart'):
      (t-s.sum)+' chips remaining';
    for(const side of ['top','bottom']){
      root.querySelector('[data-count-'+side+']').textContent=s.sum+' / '+t+' chips';
      root.querySelector('[data-remain-'+side+']').textContent=hint;
      root.querySelector('[data-meter-'+side+']').style.width=Math.min(100,s.sum/t*100)+'%';
    }
    // Quantities are changed only by the 25-chip buttons; no free-form entry.
    for(const input of inputs){
      const n=Number(input.value)||0;
      const row=input.closest('.wm-native-chip');
      const display=row.querySelector('[data-qty-display]');
      if(display.textContent!==String(n))display.textContent=String(n);
      const maxStock=Math.floor(Math.max(0,Number(input.dataset.stock)||0)/25)*25;
      const active=mode==='custom'&&Boolean(selected())&&input.dataset.style===setStyle;
      row.querySelector('[data-minus]').disabled=!active||n<25;
      row.querySelector('[data-plus]').disabled=!active||n+25>maxStock||s.sum+25>t;
    }
  }
  modes.forEach(b=>b.addEventListener('click',()=>{
    // A second click clears this choice and restores the original product gallery.
    mode=mode===b.dataset.mode?null:b.dataset.mode;
    error.textContent='';render();
  }));
  picker.addEventListener('change',()=>{error.textContent='';render();});
  sizeChoices.forEach(choice=>choice.addEventListener('click',()=>{
    if(picker.value===choice.dataset.sizeChoice)return;
    const oldStyle=style();
    picker.value=choice.dataset.sizeChoice;
    if(style()!==oldStyle)inputs.forEach(input=>input.value=0);
    picker.dispatchEvent(new Event('change',{bubbles:true}));
  }));
  root.querySelectorAll('[data-plus],[data-minus]').forEach(b=>b.addEventListener('click',()=>{
    const input=b.closest('.wm-native-chip').querySelector('[data-qty]');
    if(mode!=='custom'||!selected()||input.dataset.style!==style())return;
    const current=Number(input.value)||0;
    if(b.hasAttribute('data-plus')){
      const maxStock=Math.floor(Math.max(0,Number(input.dataset.stock)||0)/25)*25;
      if(current+25>maxStock||state().sum+25>target())return;
      input.value=String(current+25);
    }else{
      if(current<25)return;
      input.value=String(current-25);
    }
    error.textContent='';render();
  }));
  root.querySelectorAll('[data-reset]').forEach(b=>b.addEventListener('click',()=>{inputs.forEach(i=>i.value=0);error.textContent='';render();}));
  root.querySelectorAll('[data-photo]').forEach(b=>b.addEventListener('click',()=>{
    const hero=root.querySelector('[data-hero]');if(hero)hero.src=b.dataset.photo;
    root.querySelectorAll('[data-photo]').forEach(thumb=>{
      const selected=thumb===b;thumb.classList.toggle('is-selected',selected);
      thumb.setAttribute('aria-pressed',String(selected));
    });
  }));
  const preview=document.createElement('div');preview.className='wm-native-zoom';preview.innerHTML='<img alt="">';root.appendChild(preview);
  const isTouchPreview=()=>matchMedia('(hover:none)').matches;
  const closeZoom=()=>preview.classList.remove('is-open');
  root.querySelectorAll('[data-large]').forEach(img=>{
    img.addEventListener('pointerenter',ev=>{
      if(ev.pointerType==='touch'||isTouchPreview())return;
      preview.querySelector('img').src=img.dataset.large;
      const rect=img.getBoundingClientRect();
      // Place the larger preview fully within the desktop viewport.
      const previewWidth=Math.min(340,Math.max(160,innerWidth-24));
      const previewHeight=Math.min(325,Math.max(160,innerHeight-16));
      let left=rect.right+12;
      if(left+previewWidth+8>innerWidth)left=rect.left-previewWidth-12;
      preview.style.left=Math.max(8,Math.min(innerWidth-previewWidth-8,left))+'px';
      preview.style.top=Math.max(8,Math.min(innerHeight-previewHeight-8,rect.top))+'px';
      preview.classList.add('is-open');
    });
    img.addEventListener('pointerleave',ev=>{if(ev.pointerType!=='touch'&&!isTouchPreview())closeZoom();});
    img.addEventListener('click',()=>{
      if(!isTouchPreview())return;
      const alreadyOpen=preview.classList.contains('is-open');
      closeZoom();
      if(alreadyOpen)return;
      preview.querySelector('img').src=img.dataset.large;
      preview.style.left='calc(50vw - 110px)';
      preview.style.top='28vh';
      preview.classList.add('is-open');
    });
  });
  // On phones the fixed image preview is temporary and must not follow scrolling.
  document.addEventListener('pointerdown',ev=>{
    if(!isTouchPreview()||!preview.classList.contains('is-open'))return;
    if(ev.target.closest('[data-large]')&&root.contains(ev.target))return;
    closeZoom();
  },true);
  document.addEventListener('touchmove',closeZoom,{passive:true});
  document.addEventListener('scroll',closeZoom,true);
  window.addEventListener('resize',closeZoom);
  document.addEventListener('keydown',ev=>{if(ev.key==='Escape')closeZoom();});
  const base=()=>window.Shopify?.routes?.root||'/';
  async function post(path,data){
    const res=await fetch(base()+path,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(data)});
    const json=await res.json();if(!res.ok||json.status>=400)throw Error(json.description||json.message||'Cart request rejected');return json;
  }
  async function cart(){const res=await fetch(base()+'cart.js',{credentials:'same-origin'});if(!res.ok)throw Error('Cart unavailable');return res.json();}
  const group=(c,id)=>(c.items||[]).filter(line=>line.properties?._wm_native_group===id);
  add.addEventListener('click',async()=>{
    const s=state();if(!mode||!selected()||!s.valid)return;const t=target(),customMode=mode==='custom';
    add.disabled=true;add.textContent='Adding...';error.textContent='';
    const parentId=Number(selected().value);
    const groupId='wmnative-'+Date.now().toString(36)+'-'+Math.random().toString(36).slice(2,8);
    const denomData=customMode?s.chosen:s.fixedChosen;
    const setStyle=style();
    const breakdown=denomData.map(x=>(setStyle==='denominated'?'$'+x.denom.replace('Denominated ',''):x.denom)+' × '+x.qty).join(', ');
    let parentKey=null;
    try{
      await post('cart/add.js',{items:[{id:parentId,quantity:1,properties:{
        'Set Type':customMode?'Build Your Own':'Preset Mix','Set Style':setStyle==='denominated'?'Denominated':'Non-Denominated',
        'Chip Breakdown':breakdown,'Total chips':String(t),
        'Included Accessories':'1 × WinMaestros Case; 1 × Dealer Button; 2 × WinMaestros Playing Card Decks',
        '_wm_native_group':groupId,'_wm_native_test':'yes','_wm_native_series':'hermes','_wm_native_gallery_handle':'hermes','_wm_native_reference_handle':'hermes-series-chip-design'
      }}]});
      let current=await cart();
      const parent=group(current,groupId).find(x=>Number(x.id)===parentId&&!x.parent_relationship?.parent_key);
      if(!parent?.key)throw Error('Parent set not confirmed');parentKey=parent.key;
      // All four choices link tracked Hermes component SKUs to a priced parent set.
      const children=denomData.map(x=>({id:x.id,quantity:x.qty,parent_line_key:parent.key,properties:{'_wm_native_group':groupId,'_wm_native_component':'yes'}}));
      await post('cart/add.js',{items:children});current=await cart();
      const kids=group(current,groupId).filter(x=>x.properties._wm_native_component==='yes');
      if(kids.length!==denomData.length||
         kids.reduce((a,x)=>a+Number(x.quantity),0)!==t||
         kids.some(x=>x.parent_relationship?.parent_key!==parent.key)||
         denomData.some(x=>!kids.some(k=>Number(k.id)===x.id&&Number(k.quantity)===x.qty))) {
        throw Error('Nested Hermes SKU quantities not confirmed');
      }
      const subtotal=group(current,groupId).reduce((a,x)=>a+Number(x.original_line_price||0),0);
      if(subtotal!==s.expected)throw Error('Set price mismatch: expected '+money(s.expected)+' but got '+money(subtotal));
      const ids=[...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(x=>x.dataset.sectionId).filter(Boolean))];
      let sections={};if(ids.length){const response=await fetch(base()+'?sections='+encodeURIComponent(ids.join(',')),{credentials:'same-origin'});if(response.ok)sections=await response.json();}
      root.dispatchEvent(new CartAddEvent({},String(parentId),{source:'product-form-component',itemCount:1,sections}));
      const drawer=document.querySelector('cart-drawer-component');if(drawer?.open)drawer.open();
    }catch(e){
      if(parentKey){try{await post('cart/change.js',{id:parentKey,quantity:0});}catch(err){console.warn('Incomplete test set was not fully cleaned',err);}}
      error.textContent=(e?.message||'Unable to add set')+' Please check cart before trying again.';
    }finally{render();}
  });
  render();
});
